import React, { Component } from 'react'
import axios from 'axios'
import { Box, Button, TextField, Heading, Toast,Dropdown } from 'monday-ui-react-core';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;
export default class AllocateForm extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            assetName: this.props.assetName,
            description: this.props.description,
            status: this.props.status,
            stocks:this.props.stocks,
            managerId: '',
            assetId: this.props.assetId,
            allocateComment: '',
            isLoading: false,
            successOrErrorMessageNotice: '',
            isToast: false,
            isToastOpen: false,
            messageSuccessOrFailure: '',
            quantity:1,
            nameAssigned:'',
            emailAssigned:'',
            isRequest:this.props.isRequest
           
        }
    }

    async componentDidMount() {
        // Retrieve a value from local storage
        if (localStorage.getItem("managerId")) {
            this.setState({
                managerId: localStorage.getItem("managerId")
            })
        }
    }

    onChangeManagerId = (eventManagerId) => {
        this.setState({
            managerId: eventManagerId
        })
    }

    onChangeQuantity= (eventQuantity) => {
        this.setState({
            quantity: eventQuantity
        })
    }

    onChangeName = (eventName) => {
        this.setState({
            nameAssigned: eventName
        })
    }

    
    onChangeEmail = (eventEmail) => {
        this.setState({
            emailAssigned: eventEmail
        })
    }

    onChangeAllocateComments = (eventComments) => {
        this.setState({
            allocateComment: eventComments
        })
    }

    onClickAllocate = async () => {
        this.setState({
            isLoading: true
        })
        
        const { assetName, description, status, managerId, assetId, allocateComment, quantity, nameAssigned, emailAssigned, stocks, isRequest } = this.state;
        if (assetName && description && status && managerId && assetId && allocateComment) {
            console.group(stocks, quantity, isRequest,"data")
            if(stocks-quantity>=0){
            const successMessasge = "Asset allocated was successfully";
            const errorMessage = "Failed to Allocate";
            const managerError = "Invalid manager Id";
            let formData = {
                "managerId": managerId,
                "comment": allocateComment,
                "requestType": isRequest? "request" : "return",
                "assetId": assetId,
                "quantity":quantity || 1,
                "name": nameAssigned || '',
                "email": emailAssigned || '',
                "stocks":stocks,
                "assetName":assetName
            }
            await axios.post(`${baseUrl}/inventory-request`, formData)
                .then((res) => {
                    this.setState({
                        isLoading: false,
                        isToast: true,
                        messageSuccessOrFailure: successMessasge
                    })
                    window.location.replace(res.data);
                })
                .catch((err) => {
                    if (err.response.status === 401 || err.response.status === 404) {
                        this.setState({
                            isLoading: false,
                            isToast: true,
                            messageSuccessOrFailure: managerError
                        })
                            this.setState({
                                isManagerIdPresent: false
                            })
                    }
                    else {
                        this.setState({
                            isLoading: false,
                            isToast: true,
                            messageSuccessOrFailure: errorMessage
                        })
                    }

                })
            }
            else{
                this.setState({
                    isLoading: false,
                    isToast: true,
                    messageSuccessOrFailure: "Not enough quantity in stock"
                })
            }
        }
        else {
            this.setState({
                isLoading: true
            })
            const errorMessage = "Please fill all the fields";
            this.setState({
                isLoading: false,
                isToast: true,
                messageSuccessOrFailure: errorMessage,
            })
        }
    }


    render() {
        const { assetName, description, status, isRequest, managerId, allocateComment, messageSuccessOrFailure, stocks, isToast,quantity, nameAssigned, emailAssigned } = this.state;
        return (
            <>
                <div className='responsive-allocate'>
                    {
                        isToast ?
                            <div>
                                {
                                    messageSuccessOrFailure === "Asset allocated was successfully" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.POSITIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> :
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div>
                                }
                                {
                                    messageSuccessOrFailure === "Please fill all the fields" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> : null
                                }
                                {
                                    messageSuccessOrFailure === "Invalid manager Id" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> : null
                                }
                            </div> : null
                    }
                    <br />
                    <br />
                    <Box className='box' border={Box.borders.DEFAULT} paddingX={Box.paddingXs.MEDIUM} paddingY={Box.paddingYs.MEDIUM} rounded={Box.roundeds.MEDIUM}>
                        <Heading value= {this.state.isRequest?"Allocation form⬆️":"Return form⬇️"} type={Heading.types.h2} style={{ textAlign: "center" }} />
                        <TextField
                            title="Name"
                            value={assetName}
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <TextField
                            title="Description"
                            value={description }
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <TextField
                            title="Status"
                            value={status}
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <TextField
                            title="In stock"
                            value={stocks}
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <TextField
                            onChange={(eventManagerId) => this.onChangeManagerId(eventManagerId)}
                            type={TextField.types.PASSWORD}
                            value={managerId}
                            title="Asset Manager ID"
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <TextField
                            onChange={(e) => this.onChangeQuantity(e)}
                            type={Number}
                            value={quantity}
                            title="Quantity"
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <TextField
                            onChange={(eventComments) => this.onChangeAllocateComments(eventComments)}
                            value={allocateComment}
                            title="Comments"
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <TextField
                            onChange={(e) => this.onChangeName(e)}
                            type={Text}
                            value={nameAssigned}
                            title="Assignee Name(optional)"
                            requiredAsterisk={false}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <TextField
                            onChange={(e) => this.onChangeEmail(e)}
                            type={Text}
                            value={emailAssigned}
                            title="Email(optional)"                            
                            requiredAsterisk={false}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br/>
                        <Button loading={this.state.isLoading} style={{ float: 'right' }} onClick={this.onClickAllocate}>{isRequest?"Allocate":"Return"}</Button>

                    </Box>
                </div>
            </>
        )
    }
}
